
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/my-account/temp-password",
      function () {
        return require("private-next-pages/my-account/temp-password.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/my-account/temp-password"])
      });
    }
  